import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import canada from '../../../img/logos/canada.svg';
import consulat from '../../../img/logos/consulat.svg';
import cooperation from '../../../img/logos/coop.svg';
import caraibe from '../../../img/logos/caraibe.svg';

import styles from '../../../styles/partials/sponsors.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const SponsorsPartial = ({ className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <a href="https://conseildesarts.ca/" target="_blank" rel="noopener noreferrer">
                <img
                    className={classNames([styles.logo, styles.canada])}
                    src={canada}
                    alt="Conseil des arts du Canada"
                />
            </a>
            <a href="https://quebec.consulfrance.org/" target="_blank" rel="noopener noreferrer">
                <img
                    className={classNames([styles.logo, styles.consulat])}
                    src={consulat}
                    alt="Consulat général de France à Québec"
                />
            </a>
            <a
                href="https://quebec.consulfrance.org/-CFQ-"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    className={classNames([styles.logo, styles.cooperation])}
                    src={cooperation}
                    alt="Coopération France-Québec"
                />
            </a>
            <a href="https://www.etc-caraibe.fr/" target="_blank" rel="noopener noreferrer">
                <img
                    className={classNames([styles.logo, styles.caraibes])}
                    src={caraibe}
                    alt="ETC Caraïbes"
                />
            </a>
        </div>
    );
};

SponsorsPartial.propTypes = propTypes;
SponsorsPartial.defaultProps = defaultProps;

export default SponsorsPartial;
